import styled from 'styled-components'

export const MenuOptionLabel = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp8};
`
